export default class AssignmentsList {

    constructor(selector) {
        this.$plugin = $(selector);
        let $plugin = this.$plugin;
        if ($plugin.length === 0) {
            return false;
        }
        this.init();
    }

    init() {
        let el = this;
        let timer;
        $(document).on('click', '[data-tncp-assignmentslist-changetrackingstatus]', function () {
            let vm = this;
            let $vm = $(vm);
            let $form = $('[data-tncp-basicformlist="filterForm"]');
            let $calloutBox = $(document).find('[data-tncp-assignmentslist="callout"]')
            let xhrUrl = $vm.data('tncpAssignmentslistXhr');
            let currentValue = $vm.data('tncpAssignmentslistChangetrackingstatus');
            el.disableForm(el.$plugin)
            $('[data-tncp-assignmentslist-changetrackingstatus]').removeAttr('data-tncp-assignmentslist-changetrackingstatus')
            clearTimeout(timer);
            vm.request = window.xhrRequest({
                url: xhrUrl,
                method: 'POST',
            });
            vm.request.then((response) => {
                el.disableForm(el.$plugin, false)
                if (currentValue === 1) {
                    $calloutBox.find('[data-tncp-assignmentslist-value="0"]').show();
                    $calloutBox.find('[data-tncp-assignmentslist-value="1"]').hide();
                } else {
                    $calloutBox.find('[data-tncp-assignmentslist-value="0"]').hide();
                    $calloutBox.find('[data-tncp-assignmentslist-value="1"]').show();
                }
                $calloutBox.fadeIn();
                timer = setTimeout(() => {
                    $calloutBox.fadeOut();
                }, 6000);

                $form.submit();
            });
            vm.request.catch((e) => {
                reject(e);
            });
        });
    }

    disableForm($form, disable = true) {
        let $selectors = $form.find('button, input, select, textarea');
        if (disable === true) {
            $selectors.attr('disabled', true);
        } else {
            $selectors.removeAttr('disabled');
        }
    }
}

